import { is } from "ramda"

export const isString = is(String)
export const isObject = is(Object)
export const isNumber = is(Number)
export const isFunction = is(Function)
export const isArray = is(Array)
